import {
  EMPTY_SUGGESTIONS_CARD_TEST_ID,
  WRITING_GIF_HEIGHT,
  WRITING_GIF_WIDTH,
} from '@chegg-wt/core/constants/paraphraser'
import dynamic from 'next/dynamic'
import {
  EmptySuggestionCopy,
  EmptySuggestionsCardContainer,
  EmptySuggestionsCardHeading,
} from './styled'

const ImproveWritingAnimation = dynamic(() => import('./ImproveWritingAnimation'))

const EmptySuggestionsCard = () => {
  return (
    <EmptySuggestionsCardContainer>
      <ImproveWritingAnimation width={WRITING_GIF_WIDTH} height={WRITING_GIF_HEIGHT} />
      <EmptySuggestionsCardHeading
        data-test={`${EMPTY_SUGGESTIONS_CARD_TEST_ID}-heading`}
      >
        Helping you get from written to <span>well written</span>
      </EmptySuggestionsCardHeading>
      <EmptySuggestionCopy data-test={`${EMPTY_SUGGESTIONS_CARD_TEST_ID}-text`}>
        Your smart suggestions will appear here. Paste your essay, and click
        <strong> Review </strong>to begin.
      </EmptySuggestionCopy>
    </EmptySuggestionsCardContainer>
  )
}

export default EmptySuggestionsCard
